// import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import axios from "axios";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Swal from 'sweetalert2'

const Book = ({ columns }) => {
  const location = useLocation();
    const path = location.pathname.split("/")[1];
    
  const [list, setList] = useState();
  const { data, loading, error } = useFetch(`/rooms/booking/:id`);
    // console.log("data=>", data);
    
  // console.log("data=>", error);

  useEffect(() => {
    setList(data);
  }, [data]);

  const handleDelete = async (id) => {
    console.log("id=>", id);
    try {
      await axios.delete(`https://dummy-app-link.herokuapp.com/api/rooms/booking/delete/${id}`)
      .then(e=>{
        if(e.status==200){
          setTimeout(() => {
                Swal.fire({
          icon: 'success',
          title: 'Deleted successfully',
          showConfirmButton: false,
          position: 'top-end',
          timer: 2000
        })
          }, 1000);
    
      }
        console.log("hotels=>",e)
      })
      setList(list.filter((item) => item._id !== id));
    } catch (err) {
    }
  };



  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* <Link to="/users/test" style={{ textDecoration: "none" }}>
              <div className="viewButton"
                      onClick={() => handleView(params.row)}
                      >View</div>
            </Link> */}
                {/* <Link to="/users/test" style={{ textDecoration: "none" }}> */}
              <div className="viewButton"
                      // onClick={() => handleView(params.row)}
                      > Edit </div>
            {/* </Link> */}
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row._id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (

    <div className="single">
    <Sidebar />
    <div className="singleContainer">
      <Navbar />

    <div className="datatable">


      <br />

      {data.length ? (
        <DataGrid
          className="datagrid"
          rows={list}
          columns={columns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          checkboxSelection
          getRowId={(row) => row._id}
        />
      ) : (
        <img
          style={{
            height: 100,
            justifyContent: "center",
            alignContent: "center",
          }}
          src="https://cdn.dribbble.com/users/3337757/screenshots/6825268/076_-loading_animated_dribbble_copy.gif"
        />
      )}
    </div>

    </div>


    </div>

  );
};

export default Book;
